import { fmtNum, fmtCompact } from "@/lib/format";

export const Num = ({ v, line, compact = false }) => {
  const s = compact ? fmtCompact(v) : fmtNum(v, line);
  return typeof v === "number" && v < 0 ? <span className="text-red-600" data-negative="true">{s}</span> : s;
};
